import { createAsyncAction, createAction } from 'typesafe-actions'

export type FireblocksTarget = 'base' | 'quote'

export const {
  request: getFireblocksAssetBySymbolRequest,
  success: getFireblocksAssetBySymbolSuccess,
  failure: getFireblocksAssetBySymbolFailure,
} = createAsyncAction(
  'GET_FIREBLOCKS_ASSET_BY_SYMBOL_REQUEST',
  'GET_FIREBLOCKS_ASSET_BY_SYMBOL_SUCCESS',
  'GET_FIREBLOCKS_ASSET_BY_SYMBOL_FAILURE',
)<
  { symbol: string; target: FireblocksTarget },
  {
    assets: {
      id: string
      name: string
      displayName?: string
      legacyId?: string
      displaySymbol?: string
      iconUrl?: string
    }[]
    target: FireblocksTarget
  },
  { error: Error; target: FireblocksTarget }
>()

export const clearFireblocksByTarget = createAction('CLEAR_FIREBLOCKS_BY_TARGET')<{
  target: FireblocksTarget
}>()

export const clearFireblocksAll = createAction('CLEAR_FIREBLOCKS_ALL')<void>()
